/**
 * Replaces all occurrences of **surrounding text** with <strong class="bold-text">surrounding text</strong> in the given text.
 * @param {string} text - The text in which to replace the bold syntax.
 * @returns {string} The text with all occurrences of **surrounding text** replaced.
 */
export const parseBold = (text: string) => {
  if (!text) return "";
  return text.replace(
    /\*\*(.*?)\*\*/g,
    '<strong class="bold-text">$1</strong>'
  );
};
